<template>
  <div :class="[$style.item, active && $style.active]">
    <div :class="$style.title" @click="onClick">
      <h2><i></i>{{ data.title }}</h2>
    </div>
    <div :class="$style.content">
      <p>{{ data.description }}</p>
      <nuxt-link :to="`/statement/${data.id}`" target="_blank">
        查看协议 &rarr;
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    index: { type: Number, default: 0 },
  },
  data() {
    return { active: false }
  },
  mounted() {
    this.index === 0 && (this.active = true)
  },
  methods: {
    onClick() {
      this.active = !this.active
    },
  },
}
</script>

<style lang="less" module>
@padding-left: 0.84rem;
@padding-right: 0.59rem;
@icon-width: 0.16rem;
@icon-height: 0.02rem;

.icon-size(@r: 1) {
  // 十字
  .size(@icon-width * @r);
  left: -(@icon-width * @r + 0.13);

  &::before {
    .size(100%, @icon-height * @r);
    top: (@icon-width * @r - @icon-height * @r) / 2;
  }

  &::after {
    .size(@icon-height * @r, 100%);
    left: (@icon-width * @r - @icon-height * @r) / 2;
  }
}

.item {
  &:not(:first-child) {
    margin-top: 0.5em;
  }
}

.active {
  border-radius: 0.1rem;
  background-color: #feffff;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.94rem;
  padding: 0 @padding-right 0 @padding-left;
  border-bottom: 0.02rem solid #e6e6e9;
  cursor: pointer;

  h2 {
    position: relative;
    font-weight: 700;
    font-size: 16px;

    // 十字
    i {
      .icon-size();

      @media screen and (max-width: @laptop-width) {
        .icon-size(1.4);
      }

      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      &::before,
      &::after {
        content: '';
        position: absolute;
        background-color: @primary;
      }

      &::before {
        left: 0;
      }

      &::after {
        top: 0;
        transition: transform 0.3s;
      }
    }
  }

  // 箭头
  &::after {
    .size(7px, 11px);
    content: '';
    display: block;
    background: url('./images/protocol-list-icon.png') no-repeat;
    background-size: 100% 100%;
    transition: transform 0.3s;
  }

  .active & {
    border-bottom: 0;

    // 十字
    h2 i::after {
      transform: rotate(90deg);
    }

    // 箭头
    &::after {
      transform: rotate(90deg);
    }
  }
}

.content {
  height: 0;
  margin: 0 @padding-right 0 @padding-left;
  overflow: hidden;

  p {
    margin-bottom: 1.6em;
    line-height: 1.6;
  }

  a {
    display: inline-block;
    padding: 0.4em 1em;
    background-color: @primary;
    color: #fff;
    text-align: center;
    text-decoration: none;
  }

  .active & {
    height: auto;
    padding-bottom: 0.42rem;
  }
}

@media screen and (max-width: @mini-width) {
  .title {
    padding: 0.75em 1rem;

    h2 {
      font-size: 14px;

      i {
        display: none;
      }
    }
  }

  .content {
    margin: 0 1rem;

    p {
      margin-bottom: 1em;
      font-size: 12px;
    }

    .active & {
      padding-bottom: 1.25em;
    }
  }
}
</style>
